var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 100,
    viewBox: "0 0 120 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.369 9.79284C102.783 0.617089 89.5389 -3.26556 79.2118 3.21682C69.4923 9.31747 65.1438 21.2633 56.3584 28.4833C47.1476 36.0533 37.0075 36.4503 25.8558 35.0991C16.2431 33.9349 5.30302 34.1179 1.50419 45.2612C-2.61479 57.3452 3.463 71.5658 10.8193 80.8813C18.0721 90.066 28.1871 96.2175 39.3345 98.6265C61.5515 103.428 87.7312 95.3985 103.56 78.3401C119.924 60.7054 126.906 29.7955 110.369 9.79284Z",
    fill: "#B7CCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9402 42.0303C97.9402 43.5167 97.8519 44.9827 97.6841 46.4224C96.0388 60.5164 86.5615 72.2354 73.689 77.1844C69.4419 78.814 64.8268 79.71 60.0013 79.71C39.0481 79.71 22.0609 62.8404 22.0609 42.0288C22.0609 21.2173 39.0466 4.34766 60.0013 4.34766C80.956 4.34766 97.9417 21.2173 97.9417 42.0288L97.9402 42.0303Z",
    fill: "#01A324"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2919 57.9738C53.847 57.9738 52.4622 57.4031 51.4398 56.3858L39.7072 44.7119C37.5802 42.5955 37.5802 39.164 39.7072 37.0476C41.8343 34.9312 45.283 34.9312 47.4101 37.0476L55.2905 44.8886L71.1319 29.1264C73.259 27.01 76.7077 27.01 78.8348 29.1264C80.9618 31.2428 80.9618 34.6743 78.8348 36.7907L65.65 49.9096L59.1412 56.3858C58.1202 57.4017 56.7339 57.9738 55.289 57.9738H55.2919Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/CheckMark.aa4327bfa099f5d4cddf79756ea2d6d6.svg";
export { ForwardRef as ReactComponent };